<template>
  <div>
    <section
      :class="{ 'content-icon-block': true, 'wdm-100': !templateCheck }"
      v-if="contentIconData"
    >
      <div class="content-icon">
        <img
          v-if="contentIconData.icon"
          :src="contentIconData.icon"
          height="48"
          width="48"
          alt="Content Icon"
        />
      </div>
      <div class="editor-content wd-100 d-flex">
        <div
          class="custom-font tick-div-blue custm-text cont-title"
          :style="{
            '--heading-font': $root.font_family.heading,
            '--primary-btn': $root.color_schema.primary_btn,
            '--paragraph-font': $root.font_family.paragraph,
          }"
          v-html="contentIconData.content"
        ></div>
      </div>
      <div class="btn-cls" v-if="buttonCheck">
        <a
          v-if="partnerInfo && partnerInfo != ''"
          :title="partnerInfo.product_name"
          :href="getGoLink(partnerInfo.go_link, partnerInfo.slug)"
          :class="{'cta cta-primary cta-promotion custom-btn cas-link hover-btn':true,
          'text-white':
            !$root.override_ctabtntxt_color,
          'text-cta-override': $root.override_ctabtntxt_color,
          }"
          target="_blank"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          :style="{
            '--primary-btn': $root.color_schema.primary_btn,
            '--primary-btn-hover': pSBC(-0.2, $root.color_schema.primary_btn),
          }"
          ><span class="cta-text">{{ partnerInfo.cta_button_text }}</span
          ><span
            class="hover-text"
            v-for="(char, indexGo) in $root.i18n.go_to_casino"
            :key="indexGo + `conipp`"
            >{{ char }}</span
          ></a
        >
      </div>
    </section>
  </div>
</template>
<script>
import { pSBC } from "@/misc/misc-function";
export default {
  name: "ContentIcon",
  props: ["contentIconData", "partnerInfo", "buttonCheck", "templateCheck"],
  methods: {
    pSBC,
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.content-icon {
  //border-bottom: 1px solid rgb(227, 227, 227);
  margin: 0px 0px 20px -2px;
  img {
    margin: 0px;
    opacity: 1;
    width: 48px;
    height: 48px;
  }
}

.content-icon-block {
  display: block;
  box-sizing: border-box;
  padding: 20px 20px 1px 20px;
  margin: 0px 0px 20px;
  //max-width: 960px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background: rgb(255, 255, 255);
  @media (min-width: @sizes[small]) {
    display: inline-block;
    padding: 20px 20px 0 20px;
  }
}

.btn-cls {
  text-align: center;
  margin-bottom: 20px;
}

.custom-btn {
  min-width: 230px;
  width: 100%;
  margin: 0px !important;
  @media (min-width: @sizes[small]) {
    min-width: 335px;
  }
  // span {
  //   color: @white;
  // }
}

.wdm-100 {
  min-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/ContentIcon.vue